import {
    FETCHING_ACCOUNT_ASSETS,
    FETCHING_ACCOUNT_ASSETS_SUCCEEDED,
    FETCHING_ACCOUNT_ASSETS_FAILED,
    RE_TRIGGER_ASSET,
    RE_TRIGGER_ASSET_SUCCEEDED,
    RE_TRIGGER_ASSET_FAILED,
    INVALID_REPROCESSING_ASSET
} from "constants/actionTypes";
import { error } from "jquery";
import _ from "lodash";


const initState = {
    items: [],
    pagination: {
        currentPage: 0,
        totalPages: 1,
        recordsPerPage: 20,
        totalRecordsCount: 0,
    },
    error: null,
    loading: false,
    reprocessingAsset: {
        processing: false,
        success: false,
        error: null,
    },
};

function assetManagementReducer(state = initState, action) {
    switch (action.type) {

        case FETCHING_ACCOUNT_ASSETS: {
            const { page = 0 } = action.payload || {};
            return {
                ...state,
                loading: true,
                error: null
            };
        }

        case FETCHING_ACCOUNT_ASSETS_SUCCEEDED: {
            const {
                currentPage,
                recordsPerPage,
                totalPages,
                totalRecordsCount,
                records = [],
            } = action.payload;

            const items = currentPage > 0 ? [...state.items, ...records] : records;

            return {
                ...state,
                loading: false,
                items,
                error: null,
                pagination: {
                    currentPage,
                    totalPages,
                    recordsPerPage,
                    totalRecordsCount,
                },
            };
        }

        case FETCHING_ACCOUNT_ASSETS_FAILED: {
            const error = _.get(action, "payload.errors[0].message", "Something went wrong");
            return {
                ...state,
                loading: false,
                error,
            };
        }

        case RE_TRIGGER_ASSET: {
            return {
                ...state,
                reprocessingAsset: {
                    processing: true,
                    success: false,
                    error: null,
                },
            };
        }

        case RE_TRIGGER_ASSET_SUCCEEDED: {
            return {
                ...state,
                reprocessingAsset: {
                    processing: false,
                    success: true,
                    error: null,
                },
            };
        }

        case RE_TRIGGER_ASSET_FAILED: {
            const error = _.get(action, "payload.errors[0].message", "Something went wrong")            
            return {
                ...state,
                reprocessingAsset: {
                    processing: false,
                    success: false,
                    error
                },
            };
        }

        case INVALID_REPROCESSING_ASSET:
            return {
                ...state,
                reprocessingAsset: {
                    processing: false,
                    success: false,
                    error: null
                }
            };


        default:
            return state;
    }
}


export { assetManagementReducer };
